import { Button } from '@mui/material';
import * as Sentry from '@sentry/browser';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useRouteError } from 'react-router-dom';
import { useAnalysis } from '../../utils/contexts/AnalysisContext';
import generateAssetURL from '../../utils/helpers/generateAssetURL';
import useAuth from '../../utils/hooks/useAuth';
import './GeneralError.scss';

const GeneralError = ({ code = '', fullscreen = true }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { schoolAssetsPath } = useAuth();
  const { trackRawEvent, ANALYSIS_SEGMENT } = useAnalysis();
  const errorImage = generateAssetURL({
    asset: 'avatar_not_found.png',
    schoolAssetsPath
  });

  // collect error that caused this page to be rendered
  let error = useRouteError();
  console.error(error);

  if (Sentry.getClient()) {
    // send error to Sentry
    Sentry.captureException(error);
  }

  const handleExitButtonClick = (event) => {
    event.stopPropagation();
    navigate(`/`);
  };

  useEffect(() => {
    trackRawEvent(ANALYSIS_SEGMENT.SEGMENT_EVENTS.Error_Page_Viewed, {
      error: code
    });
  }, []);

  return (
    <div className='error-page'>
      <div
        className={
          fullscreen
            ? 'error-page__container__fullscreen'
            : 'error-page__container'
        }
      >
        <div className='error-page__title'>{`${t('error_title')} ${code}`}</div>
        <div className='error-page__image'>
          <img src={errorImage} alt='error' />
        </div>
        <div className='error-page__text'>
          {code == 404 ? (
            t('error_message_404')
          ) : (
            <span>
              {t('error_message')}{' '}
              <a href='mailto:soporte@blueberrymath.ai'>
                soporte@blueberrymath.ai
              </a>
            </span>
          )}
        </div>
        <div className='error-page__button'>
          <Button
            variant='contained'
            disableElevation
            onClick={handleExitButtonClick}
          >
            {t('error_button')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GeneralError;
